/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF("../../../midcrashWave.glb");
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    if (props.play) {
      actions.Waving.reset();
      actions.Waving.fadeIn(0.2);
      actions.Waving.play();
    } else {
      actions.Waving.fadeOut(1);
    }
  });

  return (
    <group ref={group} {...props} dispose={null} position={[0, 11.5, -12]}>
      <group name="Scene">
        <group
          name="SimplePlayerarma"
          position={[-0.08, -0.01, 0.03]}
          rotation={[0.03, 0, -0.01]}
          scale={0.62}
        >
          <primitive object={nodes.MAIN} />
          <skinnedMesh
            name="SimplePlayerBodyLayer1"
            geometry={nodes.SimplePlayerBodyLayer1.geometry}
            material={materials["char.014"]}
            skeleton={nodes.SimplePlayerBodyLayer1.skeleton}
          />
          <skinnedMesh
            name="SimplePlayerBodyLayer2"
            geometry={nodes.SimplePlayerBodyLayer2.geometry}
            material={materials["char_alpha.014"]}
            skeleton={nodes.SimplePlayerBodyLayer2.skeleton}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("../../../midcrashWave.glb");
